import { themeGet } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const assistantHighlightStyles = css `
  .pl-assistant--selection {
    color: ${themeGet('colors.assistant.600')};
    background-color: ${themeGet('colors.assistant.100')};
  }
`;
